/**
 * *********************
 * LANGUAGES DROPDOWN JS
 * *********************
 */

/**
 * Variables
 *
 * @type {string}
 */
var languagesButton = document.querySelector('[data-js="languages-button"]');
var languagesDropdown = document.querySelector('[data-js="languages-dropdown"]');
var languagesDropdownClassShow = 'language__not-locales_is_show';
var languagesDropdownIsShow = false;

/**
 * Function toggleDropdownLanguages
 *
 * Controls the visibility of the dropdown
 */
function toggleDropdownLanguages() {
    if(languagesDropdownIsShow) {
        languagesDropdownIsShow = false;
        languagesDropdown.classList.remove(languagesDropdownClassShow);
        document.removeEventListener('click', clickInsideLanguagesDropdown, true);
    } else {
        languagesDropdownIsShow = true;
        languagesDropdown.classList.add(languagesDropdownClassShow);
        document.addEventListener('click', clickInsideLanguagesDropdown, true);
    }
}

/**
 * Function clickInsideLanguagesDropdown
 *
 * Control the click inside the dropdown
 */
function clickInsideLanguagesDropdown() {
    var isClickInsideLanguagesButton = languagesButton.contains(event.target);
    var isClickInsideLanguagesDropdown = languagesDropdown.contains(event.target);

    if (!isClickInsideLanguagesButton && !isClickInsideLanguagesDropdown) {
        toggleDropdownLanguages();
    }
}